var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',_vm._b({attrs:{"svg-path":_vm.emptyStateSvg,"svg-height":150}},'gl-empty-state',_vm.emptyStateText,false))
}
var staticRenderFns = []

export { render, staticRenderFns }